var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3532 8.3539L5.35321 14.3539C5.25587 14.4512 5.12785 14.5005 4.99985 14.5005C4.87185 14.5005 4.74383 14.4519 4.6465 14.3539C4.45117 14.1586 4.45117 13.8419 4.6465 13.6465L10.2932 7.99989L4.6465 2.35325C4.45117 2.15791 4.45117 1.84122 4.6465 1.64589C4.84183 1.45056 5.15852 1.45056 5.35386 1.64589L11.3539 7.64589C11.5485 7.84189 11.5485 8.15856 11.3532 8.3539Z",
    fill: "#8601C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.00470e5b.svg";
export { ForwardRef as ReactComponent };